import { render, staticRenderFns } from "./DocumentDataViewer.vue?vue&type=template&id=23d464a8&scoped=true&"
import script from "./DocumentDataViewer.vue?vue&type=script&lang=ts&"
export * from "./DocumentDataViewer.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentDataViewer.vue?vue&type=style&index=0&id=23d464a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d464a8",
  null
  
)

export default component.exports